import './App.css';
import {Quicklink,ScrollReset} from './obj.js'
import discord from "./icons/ic_baseline-discord.svg"
import instagram from "./icons/mdi_instagram.svg"
import linkedIn from "./icons/mdi_linkedin.svg"
import facebook from "./icons/facebook.svg"



function Contacts(){
    return(
    
        <main className = "contacts">
            <ScrollReset/>
            <section >
                <h2>__CONTACT_US</h2>
                
            </section>
            <section className = "twocol socials">
                <h3>SOCIALS:</h3>
                <div className = "twobytwo">
                    <Quicklink src = {discord} path = "/discord">Discord</Quicklink>
                    <Quicklink src = {instagram} path = "/instagram">Instagram</Quicklink>
                    <Quicklink src = {linkedIn} path = "/linkedin">LinkedIn</Quicklink>
                    <Quicklink src = {facebook} path = "/facebook">Facebook</Quicklink>
                </div>
            </section>
            <section className = "twocol sponsors">
                <h3>SPONSORS:</h3>
                <p>Email us at <a href = "mailto:aps@monash.edu">aps@monash.edu</a></p>
            </section>
        </main>
    
    );
}

export default Contacts;